import "./topbar.scss";
import { Person, Mail } from "@material-ui/icons";
import { Link } from "react-router-dom";

export default function Topbar({ menuOpen, setMenuOpen }) {
  return (
    <div className={"topbar " + (menuOpen && "active")}>
      <div className="wrapper">
        <div className="left">
          <Link to="/#intro" className="logo">
            WEB DEVELOPER.
          </Link>
          <div className="itemContainer">
            <Person className="icon" />
            <span>+1 647 979 8407</span>
          </div>
          <div className="itemContainer">
            <Mail className="icon" />
            <span>Joshua.0331@hotmail.com</span>
          </div>
        </div>
        <div className="right">
          <div className="hamburger" onClick={()=>setMenuOpen(!menuOpen)}>
            <span className="line1"></span>
            <span className="line2"></span>
            <span className="line3"></span>
          </div>
        </div>
      </div>
    </div>
  );
}
